import { useTranslation } from 'react-i18next';
import { countryLabel, getAllCountries } from '../../utils/countries';
import { dateLocale } from '../../i18n/i18n';
import FormSelect from '../forms/formSelect';

const CountrySelect = ({ value, onChange, isMulti, ...rest }) => {

    // Re-render (and re-label) when the UI language changes. The value saved
    // stays the English country name; only the label is translated.
    useTranslation();
    const options = getAllCountries()
        .map((x) => ({ value: x, label: countryLabel(x) }))
        .sort((a, b) => a.label.localeCompare(b.label, dateLocale()));

    return (
        <FormSelect isMulti={isMulti} {...rest}
            value={
                isMulti ? (value && value.map(val => ({ value: val, label: countryLabel(val) }))) :
                    (options.find(opt => opt.value === value) || null)
            }
            options={options}
            onChange={(option) => onChange(option && (isMulti ? option.map(opt => opt.value) : option.value))}
        />
    )
}

export default CountrySelect